import { useAtom } from 'jotai';
import { useMemo } from 'react';

import type { CustomRequirementType } from '@/components/CheckRequirements/CheckRequirements.types';
import {
  orgProductsAtom,
  selectedOrganizationAtom
} from '@/pages/Organizations';
import { checkCustomRequirements } from '@/services/permissions';
import userAtom from '@/store/user.store';

export const useCustomRequirementsCheck = (
  customRequirements?: CustomRequirementType
) => {
  const [user] = useAtom(userAtom);
  const [selectedOrganization] = useAtom(selectedOrganizationAtom);
  const [orgProducts] = useAtom(orgProductsAtom);

  const hasCustomRequirements = useMemo(() => {
    return checkCustomRequirements(
      user,
      selectedOrganization,
      orgProducts,
      customRequirements
    );
  }, [user, selectedOrganization, orgProducts, customRequirements]);

  return hasCustomRequirements;
};

export default useCustomRequirementsCheck;
